import { OptionTypes } from '@/components';
import {
  ReducerTypes,
  MasterData,
  InitMasterDataTypes,
  InitMasterDataCustomTypes,
} from '@/features/products/list/const';

export const productsQueryBuilder = (data: ReducerTypes) => {
  const {
    limit,
    offset,
    color,
    gem_type,
    gem_pure,
    gem_material,
    jewelry_material,
    cat_code,
    product_keyword,
    price,
    quotation,
    sort_by,
    tags,
  } = data;
  let payload = {};

  if (gem_type) {
    payload = { ...payload, gem_type };
  }
  if (gem_pure) {
    payload = { ...payload, gem_pure };
  }
  if (tags) {
    payload = { ...payload, tags };
  }
  if (gem_material) {
    payload = { ...payload, gem_material };
  }
  if (jewelry_material) {
    payload = { ...payload, jewelry_material };
  }
  if (product_keyword) {
    payload = { ...payload, product_keyword };
  }

  if (cat_code) {
    payload = { ...payload, cat_code };
  }
  if (sort_by) {
    payload = { ...payload, sort_by };
  }

  if (color) {
    payload = { ...payload, color };
  }
  if (price) {
    if (price === 'true' || price === 'false') {
      payload = { ...payload, quotation: price };
    } else payload = { ...payload, price, quotation: 'false' };
  }
  return { ...payload, limit, offset };
};

export const initMasterData = (masterData: MasterData['product_input']): InitMasterDataTypes => {
  const result = { gem_material: [], jewelry_material: [], gem_type: [], color: [], gem_pure: [] } as InitMasterDataTypes;

  const ProductInputKeys = Object.keys(result);
  if (Array.isArray(masterData)) {
    return masterData.reduce((acc, { key, data }) => {
      if (ProductInputKeys.includes(key)) {
        acc[key as keyof InitMasterDataTypes] = data;
      }
      return acc;
    }, result);
  }

  return result;
};
export const initMasterDataCustom = (masterData: MasterData['product_input']): InitMasterDataCustomTypes => {
  const result = { gem_type: [], color: [] } as InitMasterDataCustomTypes;

  const ProductInputKeys = Object.keys(result);
  if (Array.isArray(masterData)) {
    return masterData.reduce((acc, { key, data }) => {
      if (ProductInputKeys.includes(key)) {
        acc[key as keyof InitMasterDataCustomTypes] = data;
      }
      return acc;
    }, result);
  }

  return result;
};
export const buildDropdownOptions = (data: string[]): OptionTypes[] => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map((key) => ({ value: key, text: key }));
};
